import { render, staticRenderFns } from "./coaching_portal.vue?vue&type=template&id=3a5e81b3&scoped=true&"
import script from "./coaching_portal.vue?vue&type=script&lang=js&"
export * from "./coaching_portal.vue?vue&type=script&lang=js&"
import style0 from "./coaching_portal.vue?vue&type=style&index=0&id=3a5e81b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5e81b3",
  null
  
)

export default component.exports